import { Tabs, type TabsProps } from 'antd';
import { useAppSelector } from '../../store';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import type { MultilanguageErrorState } from '../../hooks/useMultilanguageState';
import { useEffect, useState } from 'react';
import styles from './LanguageTab.module.scss';

interface LanguageTabProps {
  value?: string;
  onChange?: (value: string) => void;
  validations?: MultilanguageErrorState;
  attempted?: boolean;
}

export default function LanguageTab({ value, onChange, validations, attempted = false }: LanguageTabProps) {
  const languageList = useAppSelector((state) => state.config.languages);
  const [items, setItems] = useState<TabsProps['items']>();

  useEffect(() => {
    setItems(
      languageList.map((language) => {
        return {
          key: language.LanguageId,
          label: language.LanguageId.toUpperCase(),
          icon:
            attempted && validations && !validations[language.LanguageId] ? (
              <ExclamationCircleOutlined
                color={'red'}
                style={{ color: 'red' }}
              />
            ) : null,
        };
      })
    );
  }, [validations, attempted, languageList]);

  return (
    <div className={styles.languageTabs}>
      <Tabs
        items={items}
        activeKey={value}
        onChange={onChange}
        type="line"
      />
    </div>
  );
}

